module.exports = __webpack_public_path__ + "static/img/group-23.2f5b0f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2-coupon/group-23.png
// module id = IrIT
// module chunks = 12